/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from "@cian/http-api/shared/http";
import {
  TUsersEnableModel,
  IUsersEnableRequest,
  IMappers,
  IUsersEnableResponse,
  IUsersEnableResponseError,
  TUsersEnableResponse
} from "./types";

const defaultConfig: TUsersEnableModel = {
  apiType: "public",
  assertStatusCodes: [400, 200, 204],
  method: "POST",
  microserviceName: "chats",
  pathApi: "/v1/users/enable/",
  hostType: "api"
} as TUsersEnableModel;

function createUsersEnableModel(
  parameters: IUsersEnableRequest
): TUsersEnableModel {
  return {
    ...defaultConfig,
    parameters
  };
}

export interface IUsersEnableOptions<TResponse400, TResponse200, TResponse204> {
  httpApi: IHttpApi;
  parameters: IUsersEnableRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400, TResponse200, TResponse204>;
}

async function fetchUsersEnable<TResponse400, TResponse200, TResponse204>({
  httpApi,
  parameters,
  config,
  mappers
}: IUsersEnableOptions<TResponse400, TResponse200, TResponse204>): Promise<
  TResponse400 | TResponse200 | TResponse204 | TUsersEnableResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createUsersEnableModel(parameters),
    config
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as IUsersEnableResponseError);
    }

    if (statusCode === 200) {
      return mappers[200](response as IUsersEnableResponse);
    }

    if (statusCode === 204) {
      return mappers[204]();
    }
  }

  return { response, statusCode } as TUsersEnableResponse;
}

export { defaultConfig, createUsersEnableModel, fetchUsersEnable };
